import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

type UseConsentFormsParams = {
  residentId: string
  enabled?: boolean
}

export type ConsentForm = {
  id: string
  title: string
  createdOn: string
  createdBy: string
  isSigned: boolean
  signedOn?: string
  signedBy?: string
  hasRefusedConsent?: boolean
  consentStatus?: string
}

export const useConsentForms = ({
  residentId,
  enabled = true
}: UseConsentFormsParams) => {
  const { data, isLoading, error, refetch } = useQuery(
    ['consent-forms', residentId],
    () =>
      getJSON({
        url: `/api/list/consent-forms?resident=${residentId}`
      }),
    { enabled: enabled && !!residentId }
  )

  return {
    data: data?.result || [],
    isLoading,
    error,
    refetch
  }
}
